import React from 'react';
import { Settings, Camera, Building, AlertCircle } from 'lucide-react';

/**
 * Компонент для расширенных опций рекламной кампании
 */
const AdvancedOptionsSection = ({ 
  formData, 
  handleAdvancedChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Settings className="w-5 h-5 mr-2 text-gray-500 dark:text-gray-400" />
        Расширенные опции
      </h3>
      
      <div className="space-y-5">
        {/* Стоимость производства */}
        <div>
          <div className="flex items-center mb-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                checked={formData.advanced.includeProductionCosts}
                onChange={(e) => handleAdvancedChange('includeProductionCosts', e.target.checked)}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
                <Camera className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
                Учитывать стоимость производства контента
              </span>
            </label>
          </div>
          
          {formData.advanced.includeProductionCosts && (
            <div className="pl-6">
              <input
                type="text"
                value={formData.advanced.productionCost}
                onChange={(e) => handleAdvancedChange('productionCost', e.target.value)}
                className={`form-input w-full sm:w-2/3 ${errors.advanced_productionCost ? 'input-error' : ''}`}
                placeholder="Сумма в рублях"
              />
              {errors.advanced_productionCost && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.advanced_productionCost}
                </p>
              )}
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Включает затраты на создание рекламных материалов: дизайн, фотографии, видеосъемка и т.д.
              </p>
            </div>
          )}
        </div>

        {/* Комиссия агентства */}
        <div>
          <div className="flex items-center mb-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                checked={formData.advanced.includeAgencyFee}
                onChange={(e) => handleAdvancedChange('includeAgencyFee', e.target.checked)}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
                <Building className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
                Учитывать комиссию рекламного агентства
              </span>
            </label>
          </div>
          
          {formData.advanced.includeAgencyFee && (
            <div className="pl-6">
              <div className="flex items-center">
                <input
                  type="text"
                  value={formData.advanced.agencyFeePercent}
                  onChange={(e) => handleAdvancedChange('agencyFeePercent', e.target.value)}
                  className={`form-input w-24 ${errors.advanced_agencyFeePercent ? 'input-error' : ''}`}
                  placeholder="Процент"
                />
                <span className="ml-2 text-gray-700 dark:text-gray-300">% от бюджета кампании</span>
              </div>
              {errors.advanced_agencyFeePercent && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.advanced_agencyFeePercent}
                </p>
              )}
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Обычно составляет от 10% до 20% от рекламного бюджета
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Информационная подсказка */}
      <div className="mt-5 flex items-start space-x-3 p-3 bg-gray-100 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-700">
        <AlertCircle className="w-5 h-5 text-gray-600 dark:text-gray-400 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            О расширенных опциях
          </h4>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            Эти настройки позволяют учесть дополнительные затраты, которые часто не включаются в стандартные расчеты 
            стоимости рекламы. Они важны для точного планирования общего бюджета маркетинга.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdvancedOptionsSection;